import React, { Component } from 'react';
import withRouter from '../../helpers/withWrapper'

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import levelPrices from "../../services/levelPrice";
import getWallet from "../../services/wallet";
import { getBusoFarm, getOwnerContract, getBusoContract } from "../../services/contract";
import getContract from "../../services/contract";

import { ethers } from 'ethers';

class BusoFarm extends Component {
  state = {
    userId: 0,
    amountToClaim: 0,
    stakes: [],
    canClaimByPosition: [],
    totalStake: 0,
    stakeInput: 0,
    userAddress: ''
  };

  constructor(props) {
    super(props);
    if (props.router.params.id) {
      this.state.userId = props.router.params.id;
    } else {
      this.state.userId = 1;
    }
    this.props.onSetUserId(this.state.userId);
  }

  async componentDidMount() {
    try {
      const promise = this.initializeState();
      await toast.promise(promise, {
        pending: "Fetching Stakes",
        success: "Stakes Fetched! 👌",
        error: "Fetching failed",
      });
    } catch (error) {
      console.log(error);
    }
  }

  handleStake = async () => {
    const wallet = await getWallet();
    if (!wallet.isReadOnly) {
      const browserAddresses = await wallet.provider.listAccounts();
      this.setState({ userAddress: browserAddresses[0], isConnected: true });
    } else {
      throw new Error("Wallet not connected");
    }
    const contract = await getBusoFarm();
    const busoContract = await getBusoContract();

    const stake = this.state.stakeInput * (10**6);
    
    const allowance = ethers.BigNumber.from(await busoContract.allowance(this.state.userAddress, contract.address)).toNumber();
    console.log(allowance);
      if (allowance < stake) {
        const txn = await busoContract.approve(contract.address, stake);
        // const txn = await tokenContract.approve(contract.address, tokenAmount, {gasPrice: ethers.utils.parseUnits('100', 'gwei')});
        await txn.wait();
      }
    console.log(stake);
    const stakeTokenPromise = contract.stakeToken(stake);
    try {
      await toast.promise(
        stakeTokenPromise,
        {
          pending: `Staking in process`,
          success: 'Stake Successfull',
          error: 'Failed'
        },
        
      )
    } catch (error) {
      alert(error.reason)
    }
  }

  initializeState = async () => {
    const wallet = await getWallet();
    const matrixContract = await getContract();
    const contract = await getBusoFarm();
    const userAddress = await matrixContract.getAddressById(this.state.userId);

    // const allStakes = await contract.getUserAllStakes();
    let stake = await contract.getUserStake(1);
    console.log(stake);
    const userLastPosition = ethers.BigNumber.from(await contract.userLastStakePosition(userAddress)).toNumber();

    const totalStakedAmountBN = await contract.userStakedAmount(userAddress);
    const totalStake = parseFloat(ethers.utils.formatUnits(totalStakedAmountBN, "mwei")).toFixed(2);

    let claimByPosition = [];
    let stakes = [];
    for(let i = 1; i <= userLastPosition; i++) {
      let stake = {...(await contract.getUserStake(i))}
      stake.amount = parseFloat(ethers.utils.formatUnits(stake.amount, "mwei")).toFixed(2);
      stake.claimedAmount = parseFloat(ethers.utils.formatUnits(stake.claimedAmount, "mwei")).toFixed(2);
      stake.endTime = this.getDateInMiliSecFromSec(
        ethers.BigNumber.from(stake.endTime).toNumber()
      ).toDateString();
      const timeZone = 'America/New_York'; // Example timezone
      stake.lastClaimDate = this.getDateInMiliSecFromSec(
        ethers.BigNumber.from(stake.lastClaimDate).toNumber(), true
      ).toLocaleString();
      stake.startTime = this.getDateInMiliSecFromSec(
        ethers.BigNumber.from(stake.startTime).toNumber()
      ).toDateString();
      stake.totalRewardAmount = parseFloat(ethers.utils.formatUnits(stake.totalRewardAmount, "mwei")).toFixed(2);
      stakes[i-1] = stake;
      const canClaimDaily = await contract.canClaimDaily(i);
      claimByPosition[i-1] = canClaimDaily;
    }

    // for(let i = 0; i < allStakes.length; i++) {
      
    // }
    this.setState({stakes, totalStake, canClaimByPosition: claimByPosition})
    // const amountPerPool = parseFloat(ethers.utils.formatUnits(amountPerPoolBN, "mwei")).toFixed(2);
  }

  getDateInMiliSecFromSec(x) {
    const myDate = new Date(x * 1000);
    return myDate;
  }

  claimReward = async (positionId) => {
    try {
      const wallet = await getWallet();
      if (wallet.isReadOnly) {
        alert("Please connect your wallet");
        return;
      }
      const contract = await getBusoFarm();
      // const claimRewardPromise = contract.claimRewards(this.state.userId, poolId,
      //   {gasPrice: ethers.utils.parseUnits(wallet.maxFeePerGas.toString(), 'gwei')});
      const claimRewardPromise = contract.claimReward(
        positionId
      );
      toast.promise(claimRewardPromise, {
        pending: "Claiming Rewards in progress",
        success: "Rewards sent to your wallet! 👌",
        error: "Claiming Rewards failed",
      });

      await this.initializeState();
    } catch (error) {
      alert(error.reason);
    }
  }

  render() {
    return (
      <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
        {/* <ToastContainer position="bottom-right" /> */}
        <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
          {/* Top Panel, Matrix levels and all activies inside below div */}
          <div className="flex flex-col w-full space-y-10 sm:space-y-5">
            {/* Top panel of Dashboard mobile view inside below div */}
            <div className="flex w-full items-start justify-between space-x-10 lg:space-x-2.5 sm:space-x-0 sm:space-y-5 sm:flex-col sm:px-5">
              <div className="flex items-start flex-shrink-0 sm:flex-shrink">
                <div className="flex-shrink-0 relative w-30 h-30 rounded-full cursor-pointer sm:w-15 sm:h-15">
                  <div className="w-26 h-16 sm:h-14 sm:w-14 false rounded-full p-2">
                    <img src="/logo/solution.png" />
                  </div>
                </div>
                <div className="flex flex-col items-start ml-6 h-full justify-center my-auto">
                  <div className="flex justify-center items-center mb-1 sm:mb-2.5">
                    <h3
                      className="font-bold text-3xl mr-2.5 sm:text-xl cursor-pointer showContractId"
                      style={{ color: "#ffc10c" }}
                    >
                      Buso Staking - ID {this.state.userId}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            {/* Top panel of Dashboard mobile view inside above div */}

            {/* Top panel Partners, Team, Profit ration, Profits View inside below div */}
            <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                    <div className="flex sm:flex-col">
                      <div style={{ color: 'black' }} className="flex flex-col flex-1 sm:w-full bg-black-light rounded sm:rounded-none p-7.5 sm:p-5 mr-10 sm:mr-0 sm:mb-5">
                        <span className="text-white mb-3">Enter Amount to Stake (eg 1000, 2000, 3000)</span>
                        <div className="flex sm:flex-col">
                          <input
                            onChange={(e) => this.setState({stakeInput: e.target.value})}
                            value={this.state.stakeInput}
                            style={{background: 'white', color: 'black', fontSize: '24px'}}
                            className="w-full bg-white-100 border-2 border-transparent rounded-mini py-3 px-2 outline-none focus:border-2 focus:border-black flex-1 mr-5 sm:mr-0 sm:mb-3.5 py-2"
                            id="idbyPlan"
                            type="number"
                          />
                          <button style={{background: '', fontSize: '18px', color: "white"}}
                            onClick={this.handleStake}
                            className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-3 bg-blue-500 hover:bg-blue-700 active:bg-active-main-blue rounded-mini">
                            STAKE
                          </button>
                        </div>
                      </div>
                    </div>
            </div>
            <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
              <div className="flex w-full flex-wrap lg:flex-col">
                <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                  <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                    <div className="flex items-center">
                      <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                        My Total Stake
                      </h4>
                    </div>
                    <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                      {this.state.totalStake} BUSO
                    </span>
                  </div>
                  {/* <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                    <div className="flex items-center">
                      <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                        Total Amount in current pool
                      </h4>
                    </div>
                    <span
                      className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5"
                      id="yourTeamTreeCount"
                    >
                      {this.state.amountPerPool} USDT
                    </span>
                  </div> */}
                  {/* <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                    <div className="flex items-center">
                      <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                        My Shares
                      </h4>
                    </div>
                    <span
                      className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5"
                      id="yourTeamTreeCount"
                    >
                      {this.state.userCurrentPoolShares}
                    </span>
                  </div> */}
                  {/* <div className="lg:flex-grow sm:max-w-full flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                    <div className="flex items-center">
                      <h4 className="text-base text-lg sm:text-sm sm:whitespace-nowrap">
                        My Current pool income
                      </h4>
                    </div>
                    <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                      {this.state.currentPoolIncome} USDT
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
            {/* Top panel Partners, Team, Profit ration, Profits View inside above div */}
          </div>
          {/* Top Panel, Matrix levels and all activies inside above div */}
          <h1
            style={{
              fontSize: "25px",
              marginTop: "40px",
              marginBottom: "20px",
            }}
          >
            All Stakes for this ID
          </h1>
          <div className="sm:rounded-none z-10 flex flex-1 flex-col w-full flex-col bg-black-light rounded overflow-hidden h-full min-h-90 sm:max-h-3/4">
            <div className="overflow-auto">
              <table className="min-w-max w-full table-auto border-white-100">
                <thead>
                  <tr className="text-white-500 text-xs border-b border-white-100">
                    <th className="p-4 text-left font-normal sm:p-3 ">
                      Position
                    </th>
                    <th className="p-4 text-left font-normal sm:p-3">
                      Start Date
                    </th>
                    <th className="p-4 text-left font-normal sm:p-3">
                      End Date
                    </th>
                    {/* <th className="p-4 text-left font-normal sm:p-3">Income</th> */}
                    <th className="p-4 text-left font-normal sm:p-3">
                      Last claim
                    </th>
                    <th className="p-4 text-right font-normal sm:p-3">
                      Amount Staked
                    </th>
                    <th className="p-4 text-right font-normal sm:p-3">
                      Is Completed
                    </th>
                    <th className="p-4 text-right font-normal sm:p-3">
                      IsReinvested
                    </th>
                    <th className="p-4 text-right font-normal sm:p-3">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 text-sm font-light align-baseline">
                  {this.state.stakes.map((a, index) => {
                    return (
                      <tr
                        key={index}
                        className="border-b border-blue-100 last:border-none"
                      >
                        <td
                          style={{ border: "none" }}
                          className=" p-3 text-left whitespace-nowrap sm:p-3"
                        >
                          <div className="text-white-500 text-sm ">
                            {index + 1}
                          </div>
                        </td>

                        <td
                          style={{ border: "none" }}
                          className="p-2 text-left whitespace-nowrap sm:p-3"
                        >
                          <a
                            className="flex items-left justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max order-2 text-sm"
                            href="#"
                          >
                            {a.startTime}
                          </a>
                        </td>
                        <td
                          style={{ border: "none" }}
                          className="p-2 text-left whitespace-nowrap sm:p-3"
                        >
                          <a
                            className="flex items-center justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max order-2 text-sm"
                            href="#"
                          >
                            {a.endTime}
                          </a>
                        </td>

                        <td
                          style={{ border: "none" }}
                          className="p-3 text-left whitespace-nowrap sm:p-3"
                        >
                          <div className="text-white text-sm text-left ">
                            {a.lastClaimDate}
                          </div>
                        </td>
                        <td
                          style={{ border: "none" }}
                          className="p-3 text-left whitespace-nowrap sm:p-3"
                        >
                          <div className="text-white text-sm text-right ">
                            {a.amount} BUSO
                          </div>
                        </td>
                        <td
                          style={{ border: "none" }}
                          className="p-3 text-left whitespace-nowrap sm:p-3"
                        >
                          <div className="text-white text-sm text-right ">
                            {(a.isOver == true) ? "All claimed": "Pending"}
                          </div>
                        </td>
                        <td
                          style={{ border: "none" }}
                          className="p-3 text-left whitespace-nowrap sm:p-3"
                        >
                          <div className="text-white text-sm text-center ">
                            {(a.isReinvested == true) ? "Yes": "No"}
                          </div>
                        </td>
                        {this.state.canClaimByPosition[index] ? (
                          <td
                            style={{ border: "none" }}
                            className="p-4 text-left whitespace-nowrap sm:p-3"
                          >
                            <div className="text-white text-sm text-right ">
                              <button
                                onClick={() => this.claimReward(index+1)}
                                className="items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none py-0 px-2.5 bg-blue-600 text-white rounded !leading-30px hover:bg-blue-500 active:bg-active-main-blue w-max flex-shrink-0"
                              >
                                Claim
                              </button>
                            </div>
                          </td>
                        ) : ("")}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          <footer
            style={{ background: "#18191A" }}
            className="flex lg:flex-col items-center mt-auto justify-between lg:justify-start lg:items-start py-10 w-full lg:p-5 lg:pb-9 pb-0 lg:pb-0 z-10"
          >
            <div className="hidden lg:block mb-7.5">
              <div className="flex space-x-5 w-full">
                <a
                  className="w-6 h-6 sm:w-7 sm:h-7 flex justify-center items-center rounded-full bg-white-100 hover:bg-white-300"
                  target="_blank"
                  href="https://t.me/sxm2023"
                >
                  <svg
                    className="w-3 h-3 sm:w-4 sm:h-4"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      d="M11.915.776.841 5.168a.4.4 0 0 0 .03.755l2.79.864 1.133 3.503a.4.4 0 0 0 .653.17l1.64-1.523 3.11 2.29a.4.4 0 0 0 .627-.231l2.166-9.294a.8.8 0 0 0-1.075-.926Zm-6.483 6.74-.346 2.072-.8-2.901 7.816-5.1-6.67 5.929Z"
                      fill="#fff"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
            {/* <div id="google_translate_element"></div> */}
            {/* <div id="google_translate_element" ref={(el) => { this.container = el; }} /> */}

            <span className="text-white-500 text-xs font-normal lg:mb-2.5">
              © 2022 All Rights Reserved
            </span>
          </footer>
        </div>
      </div>
    );
  }
}

export default withRouter(BusoFarm);